'use client'

import { useState, useEffect } from 'react';
import { isAuthenticated, getToken } from '@nusrif/services';
import { getUser } from '@nusrif/services';
import { User } from '@nusrif/types';

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const token = getToken();
      const userData = getUser();
      const authenticated = isAuthenticated();
      
      if (token && userData && authenticated) {
        setIsLoggedIn(true);
        setUser(userData);
      } else {
        setIsLoggedIn(false);
        setUser(null);
      }
      
      setIsLoading(false);
    };

    // Small delay to ensure localStorage is available
    const timer = setTimeout(checkAuth, 100);
    return () => clearTimeout(timer);
  }, []);

  const checkAuthStatus = () => {
    return isAuthenticated();
  };

  return {
    user,
    isLoggedIn,
    isLoading,
    checkAuthStatus,
  };
}; 